import classes from './FullSpaseLoader.module.css'

const FullSpaseLoader = ({text = "Загрузка", isLoader=false}) => {
    return ( 
        <div className={isLoader?classes.loader:classes.loaderNot}>
            {text}
        </div>
     );
}
 
export default FullSpaseLoader;